module.exports = __webpack_public_path__ + "img/Loviisan-Aitta-logo.57dbd67c.jpg";